/*
  Swym Back in Stock, nkuku overrides.
  Built 5 Oct 2026 on a fresh copy of the LIVE theme (183970529658).

  WHAT TO EDIT: only the CONFIG block. Everything under it is plumbing.

  WHY THIS FILE EXISTS
  1. Wording. Copy typed into the Swym app does not reach the storefront, so
     the site falls back to Swym's defaults. These overrides restore nkuku's
     wording. Delete this file the day the app's own copy propagates.
  2. Consent. Subscribing enrols the shopper in nkuku's Attentive MARKETING
     sign-up unit, not only the transactional one. The default privacy line
     does not say so. EMAIL_PRIVACY below does.

  LAYOUT
     The button sits beside the quantity box with a short label. Chosen by
     nkuku on 6 Oct 2026. The label must stay short: the gap beside the
     quantity box is 199px on a tablet and the full "Email me when back in
     stock" wording needs 302px, which is what pushed it onto its own line.

  CONFIRMATION POP-UP
     The pop-up shown after a shopper subscribes. nkuku's wording, and its
     button closes the pop-up rather than offering to subscribe again. Added
     7 Oct 2026. See SUCCESS_TITLE, SUCCESS_MESSAGE and SUCCESS_CTA below.

  SMS
     Removed at the merchant's request, 29 Sep 2026. See SMS_ENABLED below and
     the matching block in the CSS file. Set both back to restore it.
*/
(function () {
  /* ------------------------------ CONFIG ------------------------------ */

  var PRIVACY_URL = 'https://www.nkuku.com/pages/privacy-policy';
  var TERMS_URL = 'https://www.nkuku.com/pages/terms-and-conditions';

  var SMS_ENABLED = false; // merchant request, 29 Sep 2026

  // If Swym has not rendered its button within this long on an out-of-stock
  // product, show the theme's own button again rather than nothing.
  var SWYM_WAIT_MS = 8000;

  var TITLE = 'Email me when back in stock';
  var DESCRIPTION =
    'Enter your email address below and we will notify you when this item is available.';
  var EMAIL_CTA = 'Notify me';

  // Must stay short: the space beside the quantity box is 199px on a tablet
  // and the full "Email me when back in stock" wording needs 302px.
  var BUTTON_LABEL = 'Notify me';

  // The confirmation pop-up, shown after a shopper has subscribed.
  // Wording set by nkuku, 7 Oct 2026.
  var SUCCESS_TITLE = 'Thank you';
  var SUCCESS_MESSAGE = "We'll let you know when this item is back in stock.";
  var SUCCESS_CTA = 'Continue shopping';

  // Plain text. Swym HTML-escapes this when it renders, so the links cannot
  // live here; they are added back in the DOM pass further down.
  var EMAIL_PRIVACY =
    'By submitting this form you agree to receive an email when this product is ' +
    'back in stock, and recurring marketing emails from nkuku at the address given. ' +
    'Consent is not a condition of any purchase. Unsubscribe any time using the link ' +
    'in any email. See our Terms & Conditions and Privacy Policy.';

  /* ---------------------------- END CONFIG ---------------------------- */

  /* ------------------------- string overrides ------------------------- */
  var OVERRIDES = {
    WatchlistFormTitle: TITLE,
    BISPAHeading: TITLE,
    WatchlistAddCTA: BUTTON_LABEL,
    ISABISOnlyDesc: DESCRIPTION,
    BISPAText: DESCRIPTION,
    EmailMeCTA: EMAIL_CTA,
    ISAPrivacy: EMAIL_PRIVACY,

    // Confirmation pop-up. Swym reads the message from two keys depending on
    // which flow rendered the pop-up, and a third for coming-soon products,
    // so all three are set to the same line.
    WatchlistSuccessMsg: SUCCESS_MESSAGE,
    ISAMsgDefaultSuccess: SUCCESS_MESSAGE,
    ComingSoonISAMsgDefaultSuccess: SUCCESS_MESSAGE,
    ISASubscribeAgainCTA: SUCCESS_CTA
  };

  function apply() {
    var rs = window._swat && window._swat.retailerSettings;
    if (!rs || !rs.Strings) return false;
    var S = rs.Strings;
    for (var key in OVERRIDES) {
      if (!Object.prototype.hasOwnProperty.call(OVERRIDES, key)) continue;
      S[key] = OVERRIDES[key];
      // Swym keeps a per-locale copy alongside the flat one; both are read.
      if (S.en) S.en[key] = OVERRIDES[key];
    }
    return true;
  }

  if (!apply()) {
    var tries = 0;
    var timer = setInterval(function () {
      if (apply() || ++tries > 100) clearInterval(timer);
    }, 100);
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function () {
    apply();
  });

  /* --------------- linkify the email privacy line only ---------------
     Swym escapes the privacy string, so "Terms & Conditions" and "Privacy
     Policy" arrive as plain words. This turns those two phrases into links.
     It matches on the exact text set above, so it can only ever touch our
     own line and never anything else Swym renders there.
  ------------------------------------------------------------------- */
  function norm(s) {
    return (s || '').replace(/\s+/g, ' ').trim();
  }

  var WANT = norm(EMAIL_PRIVACY);

  var LINKED_HTML = EMAIL_PRIVACY
    .replace(
      'Terms & Conditions',
      '<a href="' + TERMS_URL + '" target="_blank" rel="noopener">Terms &amp; Conditions</a>'
    )
    .replace(
      'Privacy Policy',
      '<a href="' + PRIVACY_URL + '" target="_blank" rel="noopener">Privacy Policy</a>'
    );

  var MARK = 'data-nk-email-privacy';

  // With SMS removed there is only ever the email pane, so this no longer has
  // to guard against overwriting Swym's SMS compliance wording. The guard is
  // kept anyway so restoring SMS cannot silently break consent text.
  function onEmailPane(el) {
    if (!SMS_ENABLED) return true;
    var scope = (el.closest && el.closest('.swym-remind-me')) || document;
    var input = scope.querySelector('#swym-remind-email-auth-input');
    return !!input && input.offsetParent !== null;
  }

  function linkify() {
    var nodes = document.querySelectorAll('.swym-privacy-info');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var mine = el.querySelector('[' + MARK + ']');
      if (!onEmailPane(el)) {
        if (mine) mine.parentNode.removeChild(mine);
        continue;
      }
      if (mine && norm(el.textContent) === WANT) continue;
      el.innerHTML = '<span ' + MARK + '>' + LINKED_HTML + '</span>';
    }
  }

  // Swym renders the product-page button before the string override can land,
  // so the label is corrected here too. Idempotent: only writes when different.
  function relabelButton() {
    var btns = document.querySelectorAll('button.swym-add-to-watchlist');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var span = b.querySelector('.swym-watchlist-cta') || b;
      if (norm(span.textContent) !== norm(BUTTON_LABEL)) {
        span.textContent = BUTTON_LABEL;
      }
      if (b.getAttribute('aria-label') !== BUTTON_LABEL) {
        b.setAttribute('aria-label', BUTTON_LABEL);
      }
    }
  }

  /* --------------------- the confirmation pop-up -----------------------
     Two things the Swym app's own settings cannot do. Both were checked
     against the live pop-up on 7 Oct 2026 before this was written.

     1. The title. The confirmation state REUSES the form's heading node
        (#swym-reminder-email-header h2) and reads it from the same string as
        the form, so renaming it in the app would rename both states and the
        form would also say "Thank you". It is swapped here instead, and
        swapped back whenever the form is showing.

     2. The button. Its label is a normal string override (above), but its
        click still ran Swym's own handler, which resets the pop-up back to
        the email box so the shopper can subscribe a second time. nkuku asked
        for it to close the pop-up. The listener below runs in the capture
        phase, which is before Swym's handler, and stops the event there; it
        then clicks Swym's own close control, so the pop-up is torn down by
        exactly the code the X button runs and the page scroll is restored.

        If that close control is ever missing, the event is left alone and
        Swym's own behaviour stands. A button that does the old thing is a
        better failure than a button that does nothing.
  --------------------------------------------------------------------- */
  function successPanel() {
    var panes = document.querySelectorAll('.swym-remind-me');
    for (var i = 0; i < panes.length; i++) {
      var pane = panes[i];
      var h2 = pane.querySelector('#swym-reminder-email-header .swym-title h2');
      if (!h2) continue;
      var subscribed = !!pane.querySelector('#swym-remind-me-subscribed-success');
      var want = subscribed ? SUCCESS_TITLE : TITLE;
      if (norm(h2.textContent) !== norm(want)) h2.textContent = want;
    }
  }

  var continueWired = false;

  function wireContinueShopping() {
    if (continueWired) return;
    continueWired = true;
    document.addEventListener(
      'click',
      function (e) {
        var btn =
          e.target && e.target.closest && e.target.closest('#remind-me-subscribe-btn');
        if (!btn) return;
        var close = document.querySelector('.swym-modal .swym-close-btn');
        if (!close) return; // nothing to close with, leave Swym's behaviour alone
        e.preventDefault();
        e.stopPropagation();
        close.click();
      },
      true
    );
  }

  /* ------------------- place the button in the quantity row -------------
     Two jobs, both verified on the live preview 5 Oct 2026:

     1. Swym injects .swym-button-bar as a SIBLING of .product-form-buttons,
        directly inside the product <form>. That puts it outside the flex row,
        so it can never line up with the quantity box by CSS alone. Moving the
        node (appendChild moves, it does not clone) keeps Swym's own click
        handler intact and makes it a real flex child.

     2. Keep the nk-bis-oos class in sync with the SELECTED VARIANT. The class
        is rendered by Liquid on first paint, but switching variants re-renders
        only the add-to-cart block, not this container, so the class goes stale
        and the shopper sees the theme's disabled button AND Swym's button at
        the same time. Swym's own button is the per-variant source of truth.

     Idempotent and safe to call on every mutation.
  --------------------------------------------------------------------- */
  function swymReady() {
    return !!(window._swat && window._swat.retailerSettings);
  }

  function placeButton() {
    var rows = document.querySelectorAll('.product-form-buttons');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var scope = (row.closest && row.closest('form, product-form-component')) || document;
      var bar = scope.querySelector('.swym-button-bar.swym-isa-button-bar');
      var atc = scope.querySelector('button.add-to-cart-button') ||
                scope.querySelector('add-to-cart-component button');

      // The theme's own add-to-cart button carries the per-variant truth: it
      // is server rendered, and the theme re-renders it on every variant
      // change. Read the state from THAT, never from whether Swym's button
      // has appeared.
      //
      // Why that matters (bug found 6 Oct 2026): Swym's SDK initialises about
      // 100ms before it injects its button. An earlier version treated "SDK
      // ready but no Swym button yet" as in-stock and stripped nk-bis-oos for
      // that gap, which un-hid the theme's own grey "Email me when back in
      // stock" button. Shoppers saw it flash on every page load. Server-
      // rendered stock state does not have that gap, so it is the only signal
      // used here.
      var inStock = !!(atc && atc.disabled === false);

      if (inStock) {
        row.classList.remove('nk-bis-oos');
        row.removeAttribute('data-nk-waiting-since');
      } else {
        row.classList.add('nk-bis-oos');
        if (bar && bar.parentElement !== row) row.appendChild(bar);

        // Safety net. nk-bis-oos hides the theme's button, so if Swym never
        // loads the shopper would be left with no button at all. If Swym has
        // not produced one within SWYM_WAIT_MS, give the theme's button back.
        var hasSwymBtn = !!(bar && bar.querySelector('button.swym-add-to-watchlist'));
        if (hasSwymBtn) {
          row.removeAttribute('data-nk-waiting-since');
        } else {
          var since = parseInt(row.getAttribute('data-nk-waiting-since') || '0', 10);
          if (!since) {
            row.setAttribute('data-nk-waiting-since', String(Date.now()));
          } else if (Date.now() - since > SWYM_WAIT_MS) {
            row.classList.remove('nk-bis-oos');
          }
        }
      }
    }
  }

  /* ---------------- the sticky bar on mobile ---------------------------
     The theme renders a second buy button in the mobile sticky footer
     (#sticky-add-to-cart). Out of stock it is labelled "Email me when back in
     stock" but is wired to nothing, on this theme AND on nkuku's live site
     today, so it is a dead button either way. Verified 5 Oct 2026.

     Rather than hide it, point it at Swym's button so it actually works. In
     stock it is left completely alone and still adds to cart.
  --------------------------------------------------------------------- */
  function wireSticky() {
    var sticky = document.getElementById('sticky-add-to-cart');
    if (!sticky) return;
    var row = document.querySelector('.product-form-buttons.nk-bis-oos');
    if (!row) {
      sticky.removeAttribute('data-nk-bis-wired');
      return;
    }
    if (sticky.getAttribute('data-nk-bis-wired') === '1') return;
    sticky.setAttribute('data-nk-bis-wired', '1');
    sticky.setAttribute('type', 'button');
    sticky.addEventListener(
      'click',
      function (e) {
        var liveRow = document.querySelector('.product-form-buttons.nk-bis-oos');
        if (!liveRow) return; // back in stock, let the theme handle it
        var target = liveRow.querySelector('button.swym-add-to-watchlist');
        if (!target) return;
        e.preventDefault();
        e.stopPropagation();
        target.click();
      },
      true
    );
  }

  function watch() {
    wireContinueShopping();
    placeButton();
    wireSticky();
    relabelButton();
    linkify();
    successPanel();
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      placeButton();
      wireSticky();
      relabelButton();
      linkify();
      successPanel();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
